export const primitiveLayoutTokens = {
    borderRadius: "4px",
    scrollbarWidth: "5px",
    topbarHeight: "4.5rem",
};

export const primitiveFontTokens = {
    fontFamilySans: "IBMPlexSans, sans-serif",
    fontFamilySansCondensed: "IBMPlexSansCondensed, sans-serif",
    fontSizeXs: "8px",
    fontSizeS: "10px",
    fontSizeXm: "11px",
    fontSizeMm: "13px",
    fontSizeM: "14px",
    fontSizeL: "16px",
    fontSizeXl: "18px",
    fontSizeXxl: "20px",
};

export const primitiveColorTokens = {
    blue: {
        "000": "#d4e8fe",
        "025": "#eff4fa",
        "040": "#f1f7fe",
        "050": "#d5e9ff8c",
        "200": "#d5dde6ff",
        "250": "#b0bfc5",
        "275": "#a3b6ca",
        "300": "#abc2dd",
        "400": "#4f7399",
        "450": "#0077ff",
        "500": "#5aa7fb",
        "525": "#4a90e2",
        "600": "#41658d",
        "625": "#3a5b80",
        "650": "#2a507d",
        "700": "#1f4067",
        "750": "#053368",
        "800": "#001d49",
        "850": "#33475b",
        "900": "#161616",
    },
    green: {
        "000": "#ceffcd",
        "100": "#d0d9b3",
        "200": "#cdf1f1",
        "300": "#74b9ba",
        "400": "#57b1b2",
        "500": "#3d991e",
        "600": "#2c6f16",
        "700": "#64e638",
    },
    orange: {
        "000": "#fff7ee",
        "050": "#fdf1e5",
        "100": "#fff1e4",
        "200": "#ffd6b1",
        "250": "#ffa700",
        "300": "#ed7500",
        "400": "#cf6600",
        "500": "#ef6c00",
    },
    red: {
        "300": "#f9a48c",
        "400": "#f94e69",
        "500": "#c7352a",
        "600": "#e70000",
    },
    pink: {
        "300": "#f5b2e1",
    },
    yellow: {
        "300": "#fae781",
    },
    purple: {
        "500": "#8457b2",
    },
    grey: {
        "075": "#f5f6f8",
        "100": "#f8f6f3",
        "150": "#f0f5f9",
        "175": "#f0f0f0",
        "200": "#edeff1",
        "250": "#ebedf0",
        "300": "#e6e6e6",
        "400": "#dddfdd",
        "450": "#dddddd",
        "500": "#e2e3e5",
        "525": "#c4c4c4",
        "550": "#9fa5b1",
        "575": "#999999",
        "600": "#636363",
        "650": "#555555",
        "700": "#666666",
        "750": "#888888",
        "800": "#333333",
        "999": "#000000",
    },
    white: {
        "100": "#ffffff",
        "200": "#f2f2f2",
        "300": "#f9f9f9",
        "350": "#f4f6f8",
        "375": "#e8e8e8",
        "400": "#e0e0e0",
        "600": "#cccccc",
        "700": "#fafafb",
    },
    brown: {
        "400": "#fb9e4442",
    },
    transparent: "transparent",
    translucentGrey: {
        "025": "#63636324",
        "050": "#63636340",
        "060": "#63636352",
    },
    translucentBlue: {
        "025": "#5aa7fb3d",
        "050": "#4a90e233",
        "500": "#0077ff3d",
        "600": "#0077ff0f",
    },
    shade: {
        0: "#ffffff",
        50: "#f5f6f7",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#33475b",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617",
    },
};
